let activeStep = 0;

const steps = document.querySelectorAll("[data-step]");

const changeActiveStep = (step) => {
  steps.forEach((inactiveSteps) => {
    inactiveSteps.classList.remove("active");
  });
  steps[step].classList.add("active");

  document.getElementById("funnel__wrapper").scrollIntoView({
    behavior: "smooth",
  });
};

if (steps.length) {
  changeActiveStep(activeStep);

  steps.forEach((step, index) => {
    step.querySelectorAll("[data-step-button]").forEach((button) => {
      console.dir(button?.dataset?.stepButton);
      button.addEventListener("click", (e) => {
        if (
          button?.dataset?.stepButton &&
          button?.dataset?.stepButton === "next"
        ) {
          activeStep++;
        } else if (
          button?.dataset?.stepButton &&
          button?.dataset?.stepButton === "prev"
        ) {
          activeStep--;
        } else {
          return;
        }

        changeActiveStep(activeStep);
        console.log(activeStep);
      });
    });
  });
}
